import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from "../common/UserContext";
import Icon4 from "../../assest/images/Icon4.png";
import Icon3 from "../../assest/images/Icon3.png";
import viewIcon from '../../assest/images/eye.png';
import x from '../../assest/images/x.png';
import { FaTrash } from "react-icons/fa";
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import config from "../../envconfig";
import { Button, InputGroup, Modal, Form } from 'react-bootstrap';
import CustomDropdown from "../common/CustomDropdown";

const List = () => {
    const [emailTemp, setEmailTemp] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchOpt3, setSearchOpt3] = useState('');
    const [searchOpt2, setSearchOpt2] = useState('');
    const [searchOpt1, setSearchOpt1] = useState('');
    const [searchTxt1, setSearchTxt1] = useState('');
    const [searchTxt3, setSearchTxt3] = useState('');
    const [searchTxt2, setSearchTxt2] = useState('');
    const [searchTxt4, setSearchTxt4] = useState('');
    const [searchOpt4, setSearchOpt4] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [groupNames, setGroupNames] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [selectedeventname, setSelectedeventname] = useState(null);
    const [selectedtoscp, setSelectedtoscp] = useState(null);
    const [selectedShipmentType, setselectedShipmentType] = useState(null);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);
    const [remarkError, setRemarkError] = useState(false);
    const [remark, setRemark] = useState("");
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
        sessionStorage.setItem('UM_UserType', UM_UserType);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId, UM_UserType]);

    const toastRef = useRef(null);
    const showToast = (type, message, options = {}) => {
        if (toastRef.current && toast.isActive(toastRef.current)) {
            toast.update(toastRef.current, {
                render: message,
                type,
                autoClose: 3000,
                ...options,
            });
        } else {
            toastRef.current = toast[type](message, {
                autoClose: 3000,
                ...options,
            });
        }
    };

    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Message Configuration", action, userCode: UM_UserCode, isError }),
            });
            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    useEffect(() => {
        const fetchGroupNames = async () => {
            try {
                const domainUserInt = parseInt(UM_UserType);
                const adminCheck = domainUserInt === 1;
                setIsAdmin(adminCheck);
                return adminCheck;
            } catch (error) {
                setError("Failed to fetch data");
                logAction('Failed to fetch data in fetchGroupNames function', true);
                console.error("Fetch Error:", error);
                return null;
            }
        };

        const fetchEmailData = async (scpId, isAdmin) => {
            try {
                logAction(`Executing API : /api/email/getData/ with parameters ${scpId}`);
                const response = await fetch(
                    `${config.API_URL}/api/email/getData/${scpId}?isAdmin=${isAdmin}`
                );

                if (!response.ok) {
                    logAction(
                        `API Execution Failed : /api/email/getData/ with parameters ${scpId}`,
                        true
                    );
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log("email data------------", data);

                // ✅ Sort by EMTPL_EmailTemplateId DESC first
                const sortedData = Array.isArray(data)
                    ? data.sort(
                        (a, b) => Number(b.EMTPL_EmailTemplateId) - Number(a.EMTPL_EmailTemplateId)
                    )
                    : [];

                console.log("sortedData", sortedData);

                logAction(
                    `Fetched ${sortedData.length} email templates for SCP ID: ${scpId}, Admin: ${isAdmin}`
                );

                // ✅ Group data based on sorted order
                const groupedMap = new Map();

                for (const row of sortedData) {
                    const id = row.EMTPL_EmailTemplateId;
                    if (!groupedMap.has(id)) {
                        groupedMap.set(id, {
                            ...row,
                            UserCodes: row.UM_UserCode ? [row.UM_UserCode] : [],
                            UserEmails: row.UM_EmailAddress ? [row.UM_EmailAddress] : [],
                            UserPhones: row.UM_PhoneNumber ? [row.UM_PhoneNumber] : [],
                            // Check if EMPTL_TemplateDetails exists (it's now an array from the new table)
                            EMPTL_TemplateDetails: row.EMPTL_TemplateDetails || []
                        });
                    } else {
                        const entry = groupedMap.get(id);
                        if (row.UM_UserCode && !entry.UserCodes.includes(row.UM_UserCode)) entry.UserCodes.push(row.UM_UserCode);
                        if (row.UM_EmailAddress && !entry.UserEmails.includes(row.UM_EmailAddress)) entry.UserEmails.push(row.UM_EmailAddress);
                        if (row.UM_PhoneNumber && !entry.UserPhones.includes(row.UM_PhoneNumber)) entry.UserPhones.push(row.UM_PhoneNumber);
                    }
                }

                const groupedData = Array.from(groupedMap.values());
                console.log("Grouped and Sorted Data (preserved DESC):", groupedData);
                setEmailTemp(groupedData);

            } catch (error) {
                logAction(`Error fetching email data: ${error.message}`, true);
                console.error("Error fetching data:", error);
            }
        };

        const init = async () => {
            const adminCheck = await fetchGroupNames();
            if (adminCheck !== null) {
                fetchEmailData(selectedScpId, adminCheck);
            }
        };

        init();
    }, [UM_GroupId, UM_CompanyID, selectedScpId, UM_UserType]);

    const handleOpt1 = (e) => {
        const newValue = e.target.value || "";
        if (newValue !== searchOpt1) {
            setSearchOpt1(newValue);
            setSearchTxt1("");
        }
    };

    const handleOpt2 = (e) => {
        const newValue = e.target.value || "";
        if (newValue !== searchOpt2) {
            setSearchOpt2(newValue);
            setSearchTxt2("");
        }
    };

    const handleTxt1 = (e) => {
        setSearchTxt1(e.target.value);
    };

    const handleTxt2 = (e) => {
        setSearchTxt2(e.target.value);
    };

    const handleStatus = (e) => {
        const newValue = e.target.value || "";
        setSelectStatus(newValue);
    };

    const filterData = emailTemp.filter(item => {
        const fieldMatch1 = !searchTxt1 || !searchOpt1 || String(item[searchOpt1]).toLowerCase().includes(searchTxt1.toLowerCase());
        const fieldMatch2 = !searchTxt2 || !searchOpt2 || String(item[searchOpt2]).toLowerCase().includes(searchTxt2.toLowerCase());
        const fieldMatch3 = !searchTxt3 || !searchOpt3 || String(item[searchOpt3]).toLowerCase().includes(searchTxt3.toLowerCase());
        const fieldMatch4 = !searchTxt4 || !searchOpt4 || String(item[searchOpt4]).toLowerCase().includes(searchTxt4.toLowerCase());
        const statusMatch = !selectStatus || item.Description === selectStatus;
        return fieldMatch1 && fieldMatch2 && fieldMatch3 && fieldMatch4 && statusMatch;
    });

    const Pagination = ({ totalRows, rowsPerPage, currentPage, paginate }) => {
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(totalRows / rowsPerPage); i++) {
            pageNumbers.push(i);
        }

        const isFirstDisabled = currentPage === 1 || pageNumbers.length === 0;
        const isPrevDisabled = currentPage === 1 || pageNumbers.length === 0;
        const isNextDisabled = currentPage === pageNumbers.length || pageNumbers.length === 0;
        const isLastDisabled = currentPage === pageNumbers.length || pageNumbers.length === 0;

        return (
            <ul className="pagination">
                <li className={isFirstDisabled ? "page-item disabled" : "page-item"}>
                    <button
                        onClick={() => !isFirstDisabled && paginate(1)}
                        className="page-linkd"
                        disabled={isFirstDisabled}
                    >
                        First
                    </button>
                </li>
                <li className={isPrevDisabled ? "page-item disabled" : "page-item"}>
                    <button
                        onClick={() => !isPrevDisabled && paginate(currentPage - 1)}
                        className="page-linkd"
                        disabled={isPrevDisabled}
                    >
                        Previous
                    </button>
                </li>
                {pageNumbers.length > 0 && pageNumbers.map(number => (
                    <li key={number} className={currentPage === number ? "page-item active" : "page-item"}>
                        <button
                            onClick={() => paginate(number)}
                            className="page-linkd"
                        >
                            {number}
                        </button>
                    </li>
                ))}
                <li className={isNextDisabled ? "page-item disabled" : "page-item"}>
                    <button
                        onClick={() => !isNextDisabled && paginate(currentPage + 1)}
                        className="page-linkd"
                        disabled={isNextDisabled}
                    >
                        Next
                    </button>
                </li>
                <li className={isLastDisabled ? "page-item disabled" : "page-item"}>
                    <button
                        onClick={() => !isLastDisabled && paginate(pageNumbers.length)}
                        className="page-linkd"
                        disabled={isLastDisabled}
                    >
                        Last
                    </button>
                </li>
            </ul>
        );
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filterData.slice(indexOfFirstRow, indexOfLastRow);

    const handleSuspendClick = (rowData) => {
        setSelectedTemplateId(rowData.EMTPL_EmailTemplateId);
        setSelectedeventname(rowData.EEVM_EventName);
        setSelectedtoscp(rowData.ToSCPM_Name);
        setselectedShipmentType(rowData.EMTPL_SHPTTYPE);
        setSelectedRowData(rowData);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedTemplateId(null);
        setRemark('');
        setRemarkError(false);
    };

    const stripHtmlTags = (str) => {
        if (!str) return "";
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    };

    const handleConfirmSuspend = async () => {
        if (!remark.trim()) {
            logAction("confirmSuspend(): Error : Remark is required!");
            setRemarkError(true);
            return;
        }
        logAction(`Attempting to suspend email template with ID: ${selectedTemplateId}`);
        try {
            setLoading(true);
            logAction(`Executing API: ${config.API_URL}/api/email/deleteTemplate/${selectedTemplateId} DATA : ${remark}`);
            const response = await fetch(`${config.API_URL}/api/email/deleteTemplate/${selectedTemplateId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ remark }),
            });

            if (!response.ok) {
                logAction(`API Execution Failed: /api/email/deleteTemplate/ with parameters ${selectedTemplateId}`);
                throw new Error('Failed to delete template');
            }

            logAction(`Successfully deleted email template with ID: ${selectedTemplateId}`);
            setEmailTemp((prevEmailTemp) =>
                prevEmailTemp.filter(template => template.EMTPL_EmailTemplateId !== selectedTemplateId)
            );

            const cleanEmailBody = stripHtmlTags(selectedRowData.EMTPL_Body);
            const transactionDetails = [
                { AUTRN_OldValue: selectedRowData.FromSCPM_Name, AUTRN_NewValue: `-`, AUTRN_ParamererName: "From" },
                { AUTRN_OldValue: selectedRowData.ToSCPM_Name, AUTRN_NewValue: "-", AUTRN_ParamererName: "To" },
                { AUTRN_OldValue: selectedRowData.Description, AUTRN_NewValue: "Delete", AUTRN_ParamererName: "Email Status" },
                { AUTRN_OldValue: "-", AUTRN_NewValue: remark, AUTRN_ParamererName: "Delete Remark" },
                { AUTRN_OldValue: selectedRowData.EEVM_EventName, AUTRN_NewValue: "-", AUTRN_ParamererName: "Event Type" },
                { AUTRN_OldValue: selectedRowData.EMTPL_SHPTTYPE, AUTRN_NewValue: `-`, AUTRN_ParamererName: "Shipment Type" },
                { AUTRN_OldValue: selectedRowData.EMTPL_Subject, AUTRN_NewValue: `-`, AUTRN_ParamererName: "Email Subject" },
                { AUTRN_OldValue: cleanEmailBody, AUTRN_NewValue: "-", AUTRN_ParamererName: "Email Template" },
            ];

            await logAudit(
                "Message Configuration",
                `Message Configuration for Event Type : ${selectedeventname}${selectedShipmentType && selectedShipmentType !== '-' ? ` ${selectedShipmentType}` : ''} deleted successfully`,
                '-',
                `${selectedeventname}${selectedShipmentType && selectedShipmentType !== '-' ? ` ${selectedShipmentType}` : ''}`,
                transactionDetails
            );

            showToast('success', `Message Configuration for Event Type : ${selectedeventname} ${selectedShipmentType && selectedShipmentType !== '-' ? ` ${selectedShipmentType}` : ''} deleted successfully.`, {
                autoClose: 3000,
                onClose: () => setLoading(false)
            });

            setIsModalOpen(false);
            setSelectedTemplateId(null);
            setRemark('');
            setRemarkError(false);
        } catch (error) {
            console.error('Error deleting template:', error);
            setLoading(false);
            logAction(`Error deleting email template for : ${selectedeventname}. Error message: ${error.message}`);
        }
    };

    const handleDetailsClick = (rowData) => {
        setSelectedEmailTemplate(rowData);
        setIsDetailsModalOpen(true);
    };

    const hideOpenModal = () => {
        setIsDetailsModalOpen(false);
    };

    const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
        const auditLogPayload = {
            AUTR_ScreenName: module,
            AUTR_OldValue: oldValue,
            AUTR_NewValue: newValue,
            AUTR_Message: message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_AuditType: 15,
            AUTR_SCPID: selectedScpId,
            AUTR_CompanyGrpId: UM_CompanyGrpID,
            AUTR_CompanyID: UM_CompanyID,
            AUTR_CreatedBy: UM_UserId,
            insertAuditTransaction: true,
            transactionDetails
        };

        try {
            const response = await fetch(`${config.API_URL}/audit/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(auditLogPayload),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };

    const dropdownOptions2 = [
        {
            id: "TransmissionMode",
            name: "Transmission Mode",
            disabled: searchOpt1 === "TransmissionMode"
        },
        ...(isAdmin
            ? [{
                id: "FromSCPM_Name",
                name: "From",
                disabled: searchOpt1 === "FromSCPM_Name"
            }]
            : []
        ),
        { id: "ToSCPM_Name", name: "To", disabled: searchOpt1 === "ToSCPM_Name" },
        { id: "EEVM_EventName", name: "Event Type", disabled: searchOpt1 === "EEVM_EventName" },
        { id: "EMTPL_SHPTTYPE", name: "Shipment Type", disabled: searchOpt1 === "EMTPL_SHPTTYPE" },
    ];

    const dropdownOptions1 = [
        {
            id: "TransmissionMode",
            name: "Transmission Mode",
            disabled: searchOpt2 === "TransmissionMode"
        },
        ...(isAdmin
            ? [{
                id: "FromSCPM_Name",
                name: "From",
                disabled: searchOpt2 === "FromSCPM_Name"
            }]
            : []
        ),
        { id: "ToSCPM_Name", name: "To", disabled: searchOpt2 === "ToSCPM_Name" },
        { id: "EEVM_EventName", name: "Event Type", disabled: searchOpt2 === "EEVM_EventName" },
        { id: "EMTPL_SHPTTYPE", name: "Shipment Type", disabled: searchOpt2 === "EMTPL_SHPTTYPE" }
    ];

    const statusDropdownOptions = [
        { id: "Active", name: "Active", disabled: false },
        { id: "Inactive", name: "Inactive", disabled: false }
    ];

    const sortedRows = [...currentRows].sort(
        (a, b) => b.EMTPL_EmailTemplateId - a.EMTPL_EmailTemplateId
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTxt1, searchTxt2, searchTxt3, searchTxt4, searchOpt1, searchOpt2, searchOpt3, searchOpt4, selectStatus]);

    // Helper function to get added users from template details
    const getAddedUsersFromTemplateDetails = (templateDetails) => {
        if (!Array.isArray(templateDetails) || templateDetails.length === 0) {
            return [];
        }

        // Filter only checked/selected template details
        const selectedDetails = templateDetails.filter(detail =>
            detail.isChecked === true || detail.EMPTLD_IsSelected === 1
        );

        // Map to user objects
        return selectedDetails.map((detail, index) => ({
            user: `Added User-${index + 1}`,
            contact: detail.data || detail.EMPTLD_DetailData || "N/A",
            isChecked: detail.isChecked,
            detailId: detail.EMPTLD_ID
        }));
    };

    return (
        <>
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />

            {loading && (
                <div style={{
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1000
                }} />
            )}

            <div className='main_container'>
                <h1 className='formHeading'>Message Configuration</h1>

                <div className="filter-container">
                    <div className='select-container_list'>
                        <CustomDropdown
                            name="searchOpt1"
                            placeholder="--Select--"
                            options={dropdownOptions1}
                            idKey="id"
                            displayKey="name"
                            value={searchOpt1}
                            onChange={handleOpt1}
                            disabled={false}
                        />
                    </div>
                    <input type='text' value={searchTxt1} onChange={handleTxt1} className='search-input searchbar' placeholder="Search"></input>

                    <div className='select-container_list'>
                        <CustomDropdown
                            name="searchOpt2"
                            placeholder="--Select--"
                            options={dropdownOptions2}
                            idKey="id"
                            displayKey="name"
                            value={searchOpt2}
                            onChange={handleOpt2}
                            disabled={false}
                        />
                    </div>
                    <input type='text' value={searchTxt2} onChange={handleTxt2} className='search-input searchbar' placeholder="Search"></input>

                    <div className='select-container_list'>
                        <CustomDropdown
                            name="statusFilter"
                            placeholder="--Select Status--"
                            options={statusDropdownOptions}
                            idKey="id"
                            displayKey="name"
                            value={selectStatus}
                            onChange={handleStatus}
                            disabled={false}
                        />
                    </div>
                </div>

                <div className="ptable-wrapper">
                    <table className="ptableClass">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Transmission Mode</th>
                                {isAdmin && <th>From</th>}
                                <th>To</th>
                                <th>Event Type</th>
                                <th>Shipment Type</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.length === 0 ? (
                                <tr>
                                    <td colSpan="9">No Records Found</td>
                                </tr>
                            ) : (
                                sortedRows.map((rowData, index) => (
                                    <tr key={rowData.EMTPL_EmailTemplateId}>
                                        <td>{indexOfFirstRow + index + 1}</td>
                                        <td>{rowData.TransmissionMode}</td>
                                        {isAdmin && <td>{rowData.FromSCPM_Name}</td>}
                                        <td>{rowData.ToSCPM_Name}</td>
                                        <td>{rowData.EEVM_EventName}</td>
                                        <td>{rowData.EMTPL_SHPTTYPE}</td>
                                        <td>{rowData.Description}</td>
                                        <td>
                                            <div className="actbtn">
                                                <Link
                                                    to={`/EmailConfigurationedit/${rowData.EMTPL_EmailTemplateId}`}
                                                    title="Edit"
                                                >
                                                    <img src={Icon3} alt="pencil" className="editicon" width={25} />
                                                </Link>
                                                <Link
                                                    title="View"
                                                    onClick={() => handleDetailsClick(rowData)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <img
                                                        src={viewIcon}
                                                        alt="pool"
                                                        className="suspendicon"
                                                        style={{ width: "18px", height: "24px" }}
                                                    />
                                                </Link>
                                                <FaTrash
                                                    title="Delete"
                                                    className="removeicon"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleSuspendClick(rowData)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {isModalOpen && (
                    <div className="popup_overlay">
                        <div className="resetpopup">
                            <h1>:: User Confirmation ::</h1>
                            <h4>
                                Are you sure you want to delete Message Configuration for this Event Type : {selectedeventname}
                                {selectedShipmentType && selectedShipmentType !== '-' ? ` ${selectedShipmentType}` : ''} ?
                            </h4>
                            <div className='remark_container'>
                                <span className='me-3 remark_label'>Remark: {remarkError && <span style={{ color: 'red' }}>*{remarkError}</span>}</span>
                                <textarea
                                    type='text'
                                    className='remark_text'
                                    value={remark}
                                    onChange={(e) => {
                                        setRemark(e.target.value);
                                        if (remarkError && e.target.value.trim() !== '') {
                                            setRemarkError(false);
                                        }
                                    }}
                                    placeholder="Enter delete remark"
                                    style={{
                                        border: '1px solid #ced4da',
                                        padding: '10px',
                                        fontSize: '16px',
                                        resize: 'none',
                                        overflow: 'auto',
                                        transition: 'height 0.3s',
                                        borderRadius: "5px",
                                        outline: "none"
                                    }}
                                />
                            </div>
                            <div className="popup_btn_container">
                                <button onClick={handleConfirmSuspend} className="yes_btn">YES</button>
                                <button onClick={handleCloseModal} className="no_btn">NO</button>
                            </div>
                        </div>
                    </div>
                )}

                <Modal
                    show={isDetailsModalOpen && !!selectedEmailTemplate}
                    onHide={hideOpenModal}
                    backdrop="static"
                    centered
                    style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)', color: "#465a64" }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#465a64", fontSize: '20px', fontWeight: "bold" }}>
                            {selectedEmailTemplate?.TransmissionMode} Information
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ marginBottom: '15px', maxHeight: '300px', overflowY: 'auto' }}>
                        <div style={{ marginBottom: '15px' }}>
                            <strong>To :</strong>
                            <div className="ptable-wrapper">
                                <table className="ptableClass">
                                    <thead>
                                        <tr style={{ backgroundColor: '#f2f2f2', textAlign: 'left' }}>
                                            <th style={{ padding: '6px', borderBottom: '1px solid #ddd', width: '60px' }}>Sr. No.</th>
                                            <th style={{ padding: '6px', borderBottom: '1px solid #ddd' }}>User</th>
                                            <th style={{ padding: '6px', borderBottom: '1px solid #ddd' }}>{selectedEmailTemplate?.TransmissionMode}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(() => {
                                            const t = selectedEmailTemplate;
                                            if (!t) {
                                                return (
                                                    <tr>
                                                        <td colSpan="3" style={{ padding: '6px', textAlign: 'center' }}>N/A</td>
                                                    </tr>
                                                );
                                            }

                                            // Get base users from UserCodes/UserEmails/UserPhones
                                            const baseUsers = [];
                                            if (t.EMTPL_TransmissionID === 1) { // Email
                                                t.UserCodes?.forEach((code, i) => {
                                                    baseUsers.push({
                                                        user: code,
                                                        contact: t.UserEmails?.[i] || "N/A",
                                                        type: "Base User"
                                                    });
                                                });
                                            } else { // SMS/WhatsApp
                                                t.UserCodes?.forEach((code, i) => {
                                                    baseUsers.push({
                                                        user: code,
                                                        contact: t.UserPhones?.[i] || "N/A",
                                                        type: "Base User"
                                                    });
                                                });
                                            }

                                            // Get added users from EMPTL_TemplateDetails (only checked/selected ones)
                                            const addedUsers = getAddedUsersFromTemplateDetails(t.EMPTL_TemplateDetails);

                                            // Combine base users and added users
                                            const combined = [...baseUsers, ...addedUsers.map(au => ({
                                                user: au.user,
                                                contact: au.contact,
                                                type: "Added User"
                                            }))];

                                            if (combined.length === 0) {
                                                return (
                                                    <tr>
                                                        <td colSpan="3" style={{ padding: '6px', textAlign: 'center' }}>No Users</td>
                                                    </tr>
                                                );
                                            }

                                            return combined.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>{idx + 1}</td>
                                                    <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>
                                                        {item.user}
                                                        {/* <span style={{ fontSize: '10px', color: '#666', marginLeft: '5px' }}>
                                                            ({item.type})
                                                        </span> */}
                                                    </td>
                                                    <td style={{ padding: '6px', borderBottom: '1px solid #eee' }}>{item.contact}</td>
                                                </tr>
                                            ));
                                        })()}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {Number(selectedEmailTemplate?.EMTPL_TransmissionID) !== 2 && (

                            <>

                                <strong >Subject :</strong>

                                <div style={{
                                    padding: '10px',
                                    borderRadius: '5px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    border: '1px solid #ced4da',
                                    overflowWrap: 'anywhere',
                                    marginTop: '10px'
                                }}>
                                    {selectedEmailTemplate?.EMTPL_Subject || "—"}
                                </div>
                            </>

                        )}

                        <div style={{ marginTop: '10px' }}>
                            <strong>{selectedEmailTemplate?.TransmissionMode} Template :</strong>
                            <div
                                style={{
                                    padding: '10px',
                                    borderRadius: '5px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    border: '1px solid #ced4da',
                                    overflowWrap: 'anywhere',
                                    marginTop: '10px'

                                }}
                                className="emailTemplate"
                                dangerouslySetInnerHTML={{
                                    __html: selectedEmailTemplate?.EMTPL_Body
                                }}
                            />

                        </div>
                    </Modal.Body>
                </Modal>

                <Pagination
                    totalRows={filterData.length}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    paginate={paginate}
                />
            </div>

            <Link className='back_btn' to={`/dashboard/EmailConfiguration`}>BACK</Link>
        </>
    );
};

export default List;

